import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../../settings/general-catalog-select.service';

export interface TypeWarrantySelectOption {
  value: string;
  label: string;
}

/** Catálogo `warranty_types` vía select unificado. */
@Injectable({ providedIn: 'root' })
export class TypeWarrantySelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<TypeWarrantySelectOption[]> {
    return this.generalCatalogSelect
      .getListOptionsByPrefix('warranty_types')
      .pipe(
        map((options) =>
          options.map((o) => ({
            value: o.value,
            label: o.label,
          })),
        ),
      );
  }
}
